import LayoutMaster from "components/layout/layout_master";
import { MaxButton, StatusMaxButton } from "components/view/button";
import HistoryBetGameShow from "components/view/history_bet_game_show";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";
import { AppReducerStateProps } from "lib/store";
import get_transaction_member_history_game from "lib/worker/api/get_transaction_member_history_game";
import { prefix } from "lib/worker/client";
import { GetServerSideProps } from "next";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { connect } from "react-redux";

interface TransactionBetGameProps {
  state: AppReducerStateProps;
  infomation: CheckWithPrefixResponse;
}

function TransactionBetGame(props: TransactionBetGameProps) {
  const { transactionsHistoryPlay } = props.state.member;
  const router = useRouter();
  const [lineid, setlineid] = useState<string | null | undefined>(null);

  useEffect(() => {
    const infomations = CheckWithPrefix({ host: props.infomation.domain });
    setlineid(infomations.lineidchat);
    reload(true);
  }, []);

  const reload = (re: boolean) => {
    get_transaction_member_history_game({
      box: re ? [] : transactionsHistoryPlay,
      start: re ? 0 : transactionsHistoryPlay.length,
      limit: 100,
    });
  };

  const statusTitle = (StatusWinLost: string): string | undefined => {
    switch (StatusWinLost ?? "") {
      case "Win":
        return "ชนะ";
      case "Lost":
        return "ขาดทุน";
      default:
        return "-";
    }
  };

  return (
    <LayoutMaster
      content_setting={{
        title: "ประวัติ (การเล่นเกม)",
        description: "ufabet คาสิโนชั้นนำ ยอดนิยมในประเทศไทย",
      }}
      information={props.infomation}
    >
      <div className="children-top-margin-top-10">
        <h1 className="text-center">ประวัติ (การเล่นเกม)</h1>
        <div className="container" style={{ paddingTop: 10 }}>
          <div className="card-add-bg">
            <div className="card-table">
              <div
                className="card-add-headings"
                style={{ paddingTop: 10, paddingBottom: 10 }}
              >
                <span className="card-add-heading text-left">วันที่</span>
                <span className="card-add-heading text-center">เกม</span>
                <span className="card-add-heading">เดิมพัน</span>
                <span className="card-add-heading">สถานะ</span>
                <span className="card-add-heading text-right">ชนะ/แพ้</span>
              </div>
              <div className="line-span" style={{ marginTop: 0 }}></div>
              {(transactionsHistoryPlay ?? []).map((value) => {
                return (
                  <>
                    <HistoryBetGameShow
                      Title={value.NameTH}
                      Amount={(value.Amount ?? 0) * -1}
                      StatusWinLost={statusTitle(value.StatusWinLost ?? "")}
                      AfterBetAmount={value.AfterBetAmount}
                      DisplayCreatedAt={value.DisplayCreatedAt}
                      StatusWinLostColor={value.StatusWinLostColor}
                      Status={`${
                        value.Uncalculated ? "สำเร็จ" : "กำลังดำเนินการ"
                      }`}
                    ></HistoryBetGameShow>
                  </>
                );
              })}
            </div>
          </div>

          <MaxButton
            title="โหลดเพิ่ม"
            onClick={() => {
              reload(false);
            }}
            className="margin-top-10"
            status={StatusMaxButton.back}
          ></MaxButton>
        </div>

        <h2
          className="font-red margin-top-20"
          style={{ fontSize: 16, marginLeft: 10 }}
        >
          *พบปัญหากรุณาติดต่อเจ้าหน้าที่ผ่านช่องทางแชท{" "}
          {router.pathname.includes("contact") == false && (
            <>
              {" "}
              {lineid != null ? (
                <Link href={lineid}>
                  <a>
                    <span>คลิก</span>
                  </a>
                </Link>
              ) : (
                <Link href={`/contact/${prefix}`}>
                  <a>
                    <span>คลิก</span>
                  </a>
                </Link>
              )}
            </>
          )}
        </h2>
      </div>
    </LayoutMaster>
  );
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  console.log("COTEXT =>", req.headers.host);
  console.log("query =>", context.query);
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  return {
    props: {
      isLogin: context.req.cookies.access_token != undefined,
      infomation: infomation,
    },
  };
};

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    state: state,
  };
};

export default connect(mapStateToProps)(TransactionBetGame);
